

import React, { Component } from 'react';
import { connect } from 'react-redux'
import StoreComponent from '../store/store';
import OrderConfirmation from '../confirmation/orderConfirmation';
import BasketComponent from '../basket/basket';

const stateManager = require('../../../../utils/state/stateManager.js');
const fatalErrorAction = require('../../../../utils/state/actions/error/fatalErrorAction');
const stringUtil = require('../../../../utils/string/stringUtil');
const constants = require('../../../../utils/domain/constants');

class Home extends Component 
{
    render()
    {

        var store = stateManager.getStore();

        if (stringUtil.areStringSame(this.props.currentComponent, "store"))
            return  <StoreComponent/>        

        if (stringUtil.areStringSame(this.props.currentComponent, "confirmation"))
            return  <OrderConfirmation/>

        if (stringUtil.areStringSame(this.props.currentComponent, "basket") || stringUtil.areStringSame(this.props.currentMode, constants.applicationMode.overPhonePayment))
            return  <BasketComponent/>

        store.dispatch(fatalErrorAction.createAction(`Unknown component: '${this.props.currentComponent}' found.`));
    }
}

const mapStateToProps = state => 
{
    return { 
        currentComponent: state.currentComponent,
        currentMode: state.currentMode,
    }
}

export default connect(mapStateToProps)(Home)